"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EAutoFocusDisabledActionTypes = void 0;
let EAutoFocusDisabledActionTypes = exports.EAutoFocusDisabledActionTypes = /*#__PURE__*/function (EAutoFocusDisabledActionTypes) {
  EAutoFocusDisabledActionTypes["SetAutoFocusDisabled"] = "autoFocusDisabled/set";
  return EAutoFocusDisabledActionTypes;
}({});